import BaseService from './BaseService';

export default class AttachmentService extends BaseService {
	// Initializing important variables
	constructor() {
		super();
		this.path = 'attachment';
		this.upload = this.upload.bind(this);
		this.download = this.download.bind(this);
	}

	download(fileName) {
		return this.fetch(
			`${this.domain}/${this.path}/download/${fileName}`,
			{
				method: 'GET',
			},
			{
				Accept: 'application/octet-stream',
				'Cache-Control': 'no-cache, no-store, must-revalidate',
				Pragma: 'no-cahce',
			}
		).then((res) => {
			return Promise.resolve(res);
		});
	}

	upload(file, fileName) {
		const formData = new FormData();
		formData.append('file', file);
		formData.append('file_name', file.name);
		return this.fetch(
			`${this.domain}/${this.path}/upload`,
			{
				method: 'POST',
				body: formData,
			},
			{
				Accept: 'application/json',
				'Cache-Control': 'no-cache, no-store, must-revalidate',
				Pragma: 'no-cahce',
			}
		).then((res) => {
			return Promise.resolve(res);
		});
	}
}
